module.exports = __webpack_public_path__ + "static/media/map.e476b450.svg";